import { render, staticRenderFns } from "./CarriersPage.vue?vue&type=template&id=50145e79"
import script from "./CarriersPage.vue?vue&type=script&lang=js"
export * from "./CarriersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports